import { Component, Input, OnInit } from "@angular/core";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart, registerables } from "chart.js";
import { VoyageReportTFCRData } from "@app/services/api/api.models";

@Component({
  selector: "app-total-fuel-consumption-diagram",
  templateUrl: "./total-fuel-consumption-diagram.component.html",
  styleUrls: ["./total-fuel-consumption-diagram.component.scss"],
})
export class TotalFuelConsumptionDiagramComponent implements OnInit {
  @Input() totalFuelConsumptionValues: VoyageReportTFCRData;

  totalFuelConsumptionChartData: any;
  totalFuelConsumptionChartOptions: any;
  totalFuelConsumptionChartPlugins: any;

  totalFuelConsumptionSum: number;

  ngOnInit(): void {
    Chart.register(...registerables);

    this.totalFuelConsumptionSum =
      this.totalFuelConsumptionValues.totalFuelConsumptionMain_t +
      this.totalFuelConsumptionValues.totalFuelConsumptionAux_t +
      this.totalFuelConsumptionValues.totalFuelConsumptionBoilers_t;

    this.totalFuelConsumptionChartData = {
      labels: ["Main Engines", "Aux Engines", "Boilers"],
      datasets: [
        {
          data: [
            this.totalFuelConsumptionValues.totalFuelConsumptionMain_t,
            this.totalFuelConsumptionValues.totalFuelConsumptionAux_t,
            this.totalFuelConsumptionValues.totalFuelConsumptionBoilers_t,
          ],
          backgroundColor: ["#99B1C9", "#B3B3B3", "#C6DEAB"],
          hoverBackgroundColor: ["#4C75A1", "#797979", "#9BC56D"],
          borderWidth: 0,
        },
      ],
    };

    this.totalFuelConsumptionChartOptions = {
      cutout: "50%",
      rotation: -90,
      circumference: 180,
      maintainAspectRatio: false,
      layout: {
        padding: {
          top: 0,
          bottom: 6,
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          color: "#000",
          font: {
            weight: "normal",
          },
          formatter: (value: number) => {
            if (value === 0) {
              return "";
            }
            return `${value.toFixed(1)} t`;
          },
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              const value = context.parsed;
              return `${context.label}: ${value.toFixed(1)} t`;
            },
          },
        },
        customLabelValue: `${this.totalFuelConsumptionSum.toFixed(1)} t`,
      },
    };
    this.totalFuelConsumptionChartPlugins = [this.createNumberPlugin(), ChartDataLabels];
  }

  createNumberPlugin() {
    return {
      id: "numberPlugin",
      afterDraw(chart) {
        const { ctx } = chart;

        const centerX = chart._metasets[0].data[0].x;
        const centerY = chart._metasets[0].data[0].y - 20;

        ctx.save();
        ctx.fillStyle = "#000000";
        ctx.font = `18px Heebo`;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";

        const value = chart.config.options.plugins?.customLabelValue || "";
        ctx.fillText(value, centerX, centerY);
        ctx.restore();
      },
    };
  }
}
